const initialState = {
  loading: false,
  data: [],
  error: null,
};

const goalCommentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_GOAL_COMMENT_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "FETCH_GOAL_COMMENT_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case "FETCH_GOAL_COMMENT_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "EMPTY_GOAL_COMMENT":
      return {
        ...state,
        data: [],
      };
    default:
      return state;
  }
};

export default goalCommentsReducer;
